import React, { FunctionComponent } from 'react'
import { Switch } from 'react-router-dom'

import Route from '../../../shared/routes/Route'
import { DetalhesCargaFactory } from '../factories/DetalhesCarga'
import { DirecionaCargaFactory } from '../factories/DirecionaCarga'
import { FiltrosLotesFactory } from '../factories/FiltrosLotes'
import { ListLotesFactory } from '../factories/ListLotes'
import { DirecionaCargaProvider } from '../hooks/direcionaCarga'
import { FiltrosProvider } from '../hooks/filtros'

const LotesRoutes: FunctionComponent = () => {
  return (
    <Switch>
      <DirecionaCargaProvider>
        <FiltrosProvider>
          <Route path="/lotes" isPrivate exact component={ListLotesFactory} />
          <Route
            path="/lotes/filtros"
            isPrivate
            exact
            component={FiltrosLotesFactory}
          />
          <Route
            path="/detalhes-carga"
            isPrivate
            exact
            component={DetalhesCargaFactory}
          />
          <Route
            path="/direciona-carga"
            isPrivate
            exact
            component={DirecionaCargaFactory}
          />
        </FiltrosProvider>
      </DirecionaCargaProvider>
    </Switch>
  )
}

export default LotesRoutes
